import { useState } from 'react'

import CopyLinkArrow from 'assets/icons/CopyLinkArrow.svg'
import DownloadIcon from 'assets/icons/Download-white.svg'
import { Button } from 'components/Button'
import { Spinner } from 'components/Spinner'

interface Props {
  logoUrl: string
  year: number
  category?: string
  brandName?: string
  isExportingPdf: boolean
  onDownloadPdf: () => void
  onNotify: (message: string) => void
}

export const BvaDetailHeader = ({
  logoUrl,
  year,
  category,
  brandName,
  isExportingPdf,
  onDownloadPdf,
  onNotify,
}: Props) => {
  const [copied, setCopied] = useState(false)

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href)
      setCopied(true)
      onNotify('Link copied to clipboard.')
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard access can be denied by the browser; nothing to recover from here.
    }
  }

  return (
    <div className="bva-header">
      <div className="bva-header__logo">
        <img src={logoUrl} alt={brandName ? `${brandName} logo` : 'Brand logo'} />
      </div>
      <div className="bva-header__title">
        <div className="bva-header__meta subtitle-xs">
          <span className="color-neutral-80">{year}</span>
          <span className="bva-header__meta-dot">·</span>
          <span className="color-neutral-80">{category}</span>
        </div>
        <p className="bva-header__headline headline-xl">{brandName} BVA</p>
      </div>
      <div className="bva-header__actions">
        <Button
          text={copied ? 'Copied!' : 'Copy link'}
          color="white"
          onClick={handleCopyLink}
          icon={<img src={CopyLinkArrow} alt="" width={20} height={20} />}
          className="bva-header__button border-2"
        />
        <Button
          text={isExportingPdf ? 'Preparing PDF…' : 'Download PDF'}
          color="black"
          disabled={isExportingPdf}
          onClick={onDownloadPdf}
          icon={isExportingPdf ? <Spinner /> : <img src={DownloadIcon} alt="" width={20} height={20} />}
          className="bva-header__button"
        />
      </div>
    </div>
  )
}
